// extracted by mini-css-extract-plugin
module.exports = {"container":"modal-container_container__65srX","close":"modal-container_close__jp97B"};